module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.galleryFS) ? _c('div', {
    staticClass: "fullscreen"
  }, [_c('div', {
    staticClass: "gallery-captions"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.galleryCaption.caption)
    }
  }), _c('p', [_vm._v(_vm._s(_vm.galleryCaption.credit))])]), _c('swiper', {
    ref: "fullscreen-gallery",
    staticClass: "gallery exhibition",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.gallery), function(image) {
    return (!_vm.loading) ? _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url,
        "alt": image.caption
      }
    })])]) : _vm._e()
  })), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "aria-label": "Previous Slide"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "aria-label": "Next Slide"
    },
    slot: "button-next"
  }), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])]), _c('div', {
    staticClass: "less",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg"
    }
  })], 1)], 1) : _vm._e()]), _c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading && !_vm.galleryFS) ? _c('div', {
    staticClass: "content exhibition"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status h-sm"
  }, [_vm._v(_vm._s(_vm.status))]), _c('div', {
    staticClass: "title-details"
  }, [_c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "h-sm teaser"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.displayDate))]), (_vm.curator) ? _c('h4', {
    staticClass: "h-sm curator"
  }, [_vm._v("curated by: " + _vm._s(_vm.curator))]) : _vm._e(), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12 hero-image"
  }, [_c('div', {
    staticClass: "hero"
  }, [(_vm.hero) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.captions
    }
  }) : _vm._e()]), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions body-captions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "title-details-mobile"
  }, [_c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "teaser h-sm"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.displayDate))])]), _c('div', {
    staticClass: "grid no-margin copy"
  }, [_c('div', {
    staticClass: "col-9_xs-12 wysiwyg",
    class: {
      noimage: !_vm.hero.url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('a', {
    attrs: {
      "href": "https://caamuseum.doubleknot.com/event/day/admission/24792"
    }
  }, [_c('img', {
    staticClass: "ticket",
    attrs: {
      "src": "/static/icons/tickets.png"
    }
  })])])])]), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 preview"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibition preview")])]) : _vm._e(), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 preview"
  }, [_c('div', {
    staticClass: "more"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/plus_black.svg"
    }
  })], 1)]), _c('swiper', {
    ref: "gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url,
        "alt": image.meta.caption
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])])], 1) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 programs"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related programs")])]) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 programs details"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedPrograms), function(program) {
    return _c('div', {
      staticClass: "col-5",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: 'current',
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1)
  }))]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related articles")])]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedArticles), function(article) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            article: article.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(article))
      }
    }), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(article.content.teaser))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 press"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("in the news")])]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 press"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.press), function(article) {
    return _c('div', {
      staticClass: "col-5",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('a', {
      attrs: {
        "href": article.link,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(article.teaser))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(_vm.articleDate(article.date)))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v("- " + _vm._s(article.publication))])])])
  }))]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 resources"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("resources")])]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 resources"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.resources), function(resource) {
    return _c('div', {
      staticClass: "col-5_xs-12",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1_xs-0"
      }
    }, [_c('a', {
      attrs: {
        "href": resource.link,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(resource.title))])])])
  }))]) : _vm._e()])]) : _vm._e()]), (!_vm.galleryFS) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0312f434"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exhibition.vue
// module id = 222
// module chunks = 1